import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Base, Card, Flex } from '@stepstone-genesis/components';
import { AppleUpdateEmailButton } from './AppleUpdateEmailButton.js';
import { AppleUpdateEmailInput } from './AppleUpdateEmailInput.js';
export const InputWithButton = () => {
    return (_jsx(Card, { p: ['spaceM', 'spaceM', 'spaceL'], children: _jsx(Flex, { flxDirection: 'column', children: _jsxs(Base, { as: 'form', autoComplete: "on", children: [_jsx(AppleUpdateEmailInput, {}), _jsx(AppleUpdateEmailButton, {})] }) }) }));
};
//# sourceMappingURL=InputWithButton.js.map